export const calcRemFromPx = (sizeInPx: number): number => sizeInPx / 16;
